import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getNodeServiceBaseUrl } from "../../../config/apiBase";
import { EmptyState, ErrorState, Skeleton, PageHeader } from "../../../shared-ui/States";
import "../../../shared-ui/crane-tokens.css";

const token = () => localStorage.getItem("zTaskAuthToken") || "";

export default function GlobalSearchPage() {
  const [q, setQ] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) {
      setGroups([]);
      return;
    }
    const t = setTimeout(async () => {
      setBusy(true);
      setErr("");
      try {
        const res = await fetch(
          `${getNodeServiceBaseUrl()}/api/platform/search?q=${encodeURIComponent(q.trim())}`,
          { headers: { Authorization: `Bearer ${token()}`, "X-Client": "web" } }
        );
        const body = await res.json();
        if (!res.ok) throw new Error(body.message || `HTTP ${res.status}`);
        setGroups(body.data?.groups || []);
      } catch (e) {
        setErr(e.message);
        setGroups([]);
      } finally {
        setBusy(false);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="crane-page">
      <PageHeader
        crumbs={["Enterprise Platform", "Administration", "Global Search"]}
        title="Global search"
        description="Search live tenant data across customers, work orders, invoices, assets, and inventory. No placeholder results."
      />
      <input
        className="crane-input"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search customers, work orders, invoices, assets, inventory…"
        style={{ width: "100%", maxWidth: 720, padding: 12, fontSize: 16, marginBottom: 16 }}
        autoFocus
      />
      {busy && <Skeleton rows={4} />}
      {err && <ErrorState title="Search failed" description={err} onRetry={() => setQ(q + " ")} />}
      {!busy && !err && q.trim().length >= 2 && groups.length === 0 && (
        <EmptyState title="No results" description={`Nothing matched “${q.trim()}”.`} />
      )}
      {!busy &&
        groups.map((g) => (
          <div key={g.type} className="crane-card" style={{ marginBottom: 16 }}>
            <div className="crane-card__header">
              <h3 className="crane-card__title">{g.label}</h3>
              <span className="crane-badge">{(g.items || []).length}</span>
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {(g.items || []).map((item) => (
                <li
                  key={`${g.type}-${item.id}`}
                  style={{
                    padding: "10px 12px",
                    borderBottom: "1px solid var(--crane-surface-low)",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 600 }}>{item.title}</div>
                    {item.subtitle && (
                      <div style={{ color: "var(--crane-on-surface-variant)", fontSize: 13 }}>{item.subtitle}</div>
                    )}
                  </div>
                  {item.href && (
                    <Link to={item.href} style={{ alignSelf: "center", color: "var(--crane-primary)", fontWeight: 600 }}>
                      Open
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      {q.trim().length < 2 && !busy && (
        <EmptyState title="Start typing" description="Enter at least 2 characters to search live data. Tip: Ctrl+K from any screen." />
      )}
    </div>
  );
}
